import {useEffect} from 'react';

import {useAuth0} from '@auth0/auth0-react';
import {setUser} from '@sentry/react';

export const useSentry = () => {
    const {user, isLoading} = useAuth0();

    useEffect(() => {
        if (!isLoading && user) {
            setUser({
                id: user.sub,
                email: user.email,
                username: user.name,
            });
        }
    }, [user, isLoading]);
};
